import React from 'react'

import { LayoutEditorVisibilityFiltersControl } from 'features/views/LayoutEditor/controls/LayoutEditorVisibilityFiltersControl'
import {
    Widget,
    WidgetAdminControlsComponent,
    WidgetComponent,
} from 'features/views/LayoutEditor/types'

import { Box } from 'ui/components/Box'
import { Divider } from 'ui/components/Divider'

export type DividerWidgetType = Widget<{}>

type DividerWidgetProps = {}

const DividerWidgetComponent: WidgetComponent<DividerWidgetType, DividerWidgetProps> = () => {
    return (
        <Box flex column py="l">
            <Divider type="default" variant="strong" />
        </Box>
    )
}

export const DividerWidget = React.memo(DividerWidgetComponent)

type DividerWidgetAdminControlsProps = {}

export const DividerWidgetAdminControls: WidgetAdminControlsComponent<
    DividerWidgetType,
    DividerWidgetAdminControlsProps
> = ({ widget, onChange }) => {
    return (
        <Box flex column height="full" overflowY="auto" pb="l">
            <LayoutEditorVisibilityFiltersControl
                defaultOpen={true}
                widget={widget}
                onChange={onChange}
            />
        </Box>
    )
}
